export default __webpack_public_path__ + "static/media/stoyan.d98eb53f.jpeg";